import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

export interface IzaConfig {
  ahriApiUrl: string;
  autosync: { apiUrl: string; token: string };
  pharmaDashApiUrl: string;
}

export const IZA_CONFIG = new InjectionToken<IzaConfig>('IZA_CONFIG');

/**
 * Stream do CNPJ selecionado, fornecido pelo host (Otimiza é a fonte da verdade).
 * A Iza não escolhe CNPJ — ela reflete o que o host tem selecionado.
 */
export const IZA_CNPJ_STREAM = new InjectionToken<Observable<string | null>>('IZA_CNPJ_STREAM');

/**
 * Callback do host para abrir o seletor de CNPJ. A Iza não escolhe CNPJ, mas
 * precisa de um para conversar — sem este provider ela só mostra o aviso.
 */
export const IZA_REQUEST_CNPJ_SELECTION = new InjectionToken<() => void>(
  'IZA_REQUEST_CNPJ_SELECTION'
);
